import { useState, createContext } from 'react';

export const AppHeaderContext = createContext<{
  titleContainer: HTMLDivElement | null;
  actionContainer: HTMLDivElement | null;
  setTitleContainer: (container: HTMLDivElement | null) => void;
  setActionContainer: (container: HTMLDivElement | null) => void;
}>({
  titleContainer: null,
  actionContainer: null,
  setTitleContainer: () => {
    throw new Error('setTitleContainer was not initialized');
  },
  setActionContainer: () => {
    throw new Error('setActionContainer was not initialized');
  }
});
export const AppHeaderProvider = ({ children }: { children: React.ReactNode }) => {
  const [titleContainer, setTitleContainer] = useState<HTMLDivElement | null>(null);
  const [actionContainer, setActionContainer] = useState<HTMLDivElement | null>(null);

  return (
    <AppHeaderContext.Provider
      value={{
        titleContainer,
        actionContainer,
        setTitleContainer,
        setActionContainer
      }}
    >
      {children}
    </AppHeaderContext.Provider>
  );
};
